if (!customElements.get('component-matching-product')) {
  customElements.define('component-matching-product', class MatchingProduct extends HTMLElement {
    constructor() {
      super();
      this.props = {
        productHandle: '',
      }
      this.state = {
        product: {}
      }
      this.errorElementSelector = '.matching-product-item-selection .error';
    }

    async connectedCallback() {
      const container = document.querySelector('component-matching-product');
      this.props.productHandle = container.getAttribute('data-prod-handle');
      try {
        this.hideError();
        const response = await fetch(`${window.Shopify.routes.root}products/${this.props.productHandle}.json`);
        if (response.ok) {
          this.state.product = await response.json();
          this.loadColor();
          this.loadSizes();
          this.addToBagListener();
          this.addReviewsListener();
          this.configureGallery();
        } else {
          console.error(`Getting product data failed... ${this.props.productHandle}`);
        }
      } catch (error) {
        console.error(`Something failed: ${error}`);
      }
    }

    loadSizes() {
      const sizesDropdown = document.querySelector('component-matching-product .matching-product-item-selection .js-size-dropdown');
      this.state.product.product.variants.forEach((variant) => {
        const option = document.createElement('option');
        option.text = variant.option2;
        option.value = variant.id;
        if (variant.inventory_quantity === 0) {
          option.text = `${variant.option2} (out of stock)`
          option.disabled = true;
        }
        sizesDropdown.add(option);
      });
    }

    loadColor() {
      const colorLabel = document.querySelector('component-matching-product .matching-product-item-selection .color .js-color');
      colorLabel.innerHTML = this.state.product.product.variants[0].option1;
    }

    addReviewsListener() {
      const reviews = document.querySelector('component-matching-product .matching-product-item-selection .js-review-stars');
      reviews.addEventListener('click', () => {
        window.open(`${window.Shopify.routes.root}products/${this.props.productHandle}`, '_self');
      });
    }

    addToBagListener() {
      const addToBagBtn = document.querySelector('component-matching-product .matching-product-item-selection .js-add-to-bag-btn');
      addToBagBtn.addEventListener('click', async () => {
        const sizeDropDown = document.querySelector('component-matching-product .matching-product-item-selection .js-size-dropdown');
        const payload = {
          id: sizeDropDown.value,
          quantity: 1,
          properties: {
            _tags: filterProductTags(sizeDropDown.dataset.productTags.split(','))
          }
        };
        addToBagBtn.innerText = 'Adding to Bag';
        window.cartManager.addItem(payload).then(() => {
          window.dispatchEvent(new CustomEvent('update-cart'));
        }).catch(() => {
          this.showError('There was a problem adding the item to the cart, please try again later.');
        })
        addToBagBtn.innerText = 'Add to Bag';
      });
    }

    configureGallery() {
      const images = document.querySelectorAll('component-matching-product .matching-product-pics-mobile .js-gallery-image');
      const imageDots = document.querySelectorAll('component-matching-product .matching-product-pics-mobile .js-gallery-dots svg ellipse');

      images.forEach((image, index) => imageDots[index].setAttribute('data-index', image.getAttribute('data-index')));

      const intersObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            imageDots.forEach((dot) => {
              dot.classList.remove('dot-active');
            });
            Array.from(imageDots).find((dot) => dot.getAttribute('data-index') === entry.target.dataset.index).classList.add('dot-active');
          }
        });
      }, {
        root: this.querySelector('component-matching-product .matching-product-pics-mobile .js-gallery'),
        rootMargin: "0px",
        threshold: 0.4
      });

      images.forEach((image) => intersObserver.observe(image));
    }

    showError(error) {
      const errorElement = document.querySelector(this.errorElementSelector);
      errorElement.classList.remove('hidden');
      errorElement.innerHTML = error;
    }

    hideError() {
      const errorElement = document.querySelector(this.errorElementSelector);
      errorElement.classList.add('hidden');
    }
  });
}
